module.exports = __webpack_public_path__ + "static/media/MEMBRESIA platinum.299818ab.png";